import { configureStore } from '@reduxjs/toolkit';
import appReducer from './appSlice';
import deviceTermsReducer, { DeviceTermsState } from './deviceTermsSlice';
import studioCacheReducer, { StudioCacheState } from './studioCacheSlice';
import { studioCachePersistConfig } from './studioCachePersistence';
import billingCacheReducer from './billingCacheSlice';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'characters',
    'characters_user_id',
    'characters_refreshed_at',
    'voices',
    'voices_user_id',
    'voices_refreshed_at',
    'book_orders',
    'book_orders_user_id',
    'book_orders_refreshed_at',
    'editStoryDrafts',
    'gambitBannerDismissedByUser',
  ],
};

const persistedReducer = persistReducer(persistConfig, appReducer);

export const store = configureStore({
  reducer: {
    app: persistedReducer,
    billingCache: billingCacheReducer,
    deviceTerms: persistReducer<DeviceTermsState>({ key: 'deviceTerms', storage, whitelist: ['byAccount'] }, deviceTermsReducer),
    studioCache: persistReducer<StudioCacheState>(studioCachePersistConfig, studioCacheReducer),
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
